import { ServerApiService } from './service';

export const serverApi = new ServerApiService({
  baseURL: process.env.REACT_APP_SERVER_API,
  headers: {
    'X-Username': 'cesadmin',
  },
});
